
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 25 25","fill":"#F8F8FA","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 12.75H6a3.75 3.75 0 00-3.75 3.75v5.25h1.5V16.5A2.25 2.25 0 016 14.25h12a2.25 2.25 0 012.25 2.25v5.25h1.5V16.5A3.75 3.75 0 0018 12.75zM12 11.25a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7.5a3 3 0 110 6 3 3 0 010-6z"}})])
          )
        }
      }
    